export function useImageCdn() {

    interface ImgBindings {
        src: string;
        sizes: string;
        srcset: string;
    }

    const runtimeConfig = useRuntimeConfig();

    const getImageUrl = (path: string) : string => {
        return `${runtimeConfig.public.cdnRoot}${path}`;
    };

    const isCloudflareImagesUrl = (url: string | null | undefined): boolean => !!url && url.includes('imagedelivery.net');

    const fixedWidthImageParams = (imageUrl: string | null | undefined, imageWidth: number, ar: number|null = null, customParams: string|null = '') : ImgBindings => {
        if(!imageUrl) {
            return <ImgBindings>{ src: '', sizes: `${imageWidth}`, srcset: '' };
        }
        if(isCloudflareImagesUrl(imageUrl)) {
            return <ImgBindings>{
                src: imageUrl,
                sizes: `${imageWidth}`,
                srcset: imageUrl,
            };
        }

        let imgixCommonParams = `auto=format${customParams}`;
        if(ar) {
            imgixCommonParams = `ar=${ar}&fit=crop&crop=entropy&${imgixCommonParams}`
        }
        return <ImgBindings>{
            src: `${imageUrl}?w=${imageWidth}&${imgixCommonParams}`,
            sizes: `${imageWidth}`,
            srcset: `${imageUrl}?w=${imageWidth}&dpr=1&${imgixCommonParams} 1x,
                     ${imageUrl}?w=${imageWidth}&dpr=2&${imgixCommonParams} 2x,
                     ${imageUrl}?w=${imageWidth}&dpr=3&${imgixCommonParams} 3x,
                     ${imageUrl}?w=${imageWidth}&dpr=4&${imgixCommonParams} 4x`,
        };
    };

    return {
        getImageUrl,
        fixedWidthImageParams
    }
}
